module.exports = __webpack_public_path__ + "img/newicon6on.1dffdfa7.svg";